import { Box, TextArea, Token } from '@revolut-internal/ui-kit'
import styled from 'styled-components'

export const StyledTextArea = styled(TextArea)`
  & > div,
  & > div[aria-disabled='true'] {
    background-color: transparent !important;
    padding-bottom: 0;
  }
`

export const StyledBacking = styled(Box)`
  border-radius: ${Token.radius.r12};

  transition: ${Token.transition.background}, ${Token.transition.transform};
  background-color: ${Token.color.searchBackground};

  :focus-within,
  :hover,
  &[data-focused='true'] {
    background-color: ${Token.color.greyTone10};
  }
`
